import options from './thing-battery.component';

export default {
    selector: 'dtAsThingBattery',
    options
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-battery/index.js